import crypto from 'crypto';

import { ENCRYPTION_CIPHER } from '../config';

export const encryptStringData = data => {
    const IV = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(ENCRYPTION_CIPHER), IV);
    let cryptedData = cipher.update(data.toString());
    cryptedData = Buffer.concat([cryptedData, cipher.final()]);

    return IV.toString('hex') + ':' + cryptedData.toString('hex');
};

export const decryptStringData = data => {
    const dataParts = data.split(':');
    const IV = Buffer.from(dataParts.shift(), 'hex');
    let encryptedData = Buffer.from(dataParts.join(':'), 'hex');

    const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(ENCRYPTION_CIPHER), IV);
    let decrypted = decipher.update(encryptedData);
    decrypted = Buffer.concat([decrypted, decipher.final()]);

    return decrypted.toString();
};